import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { StoreProvider } from './Utils/Store';
import { CartProvider } from './Utils/CartContext';
import { WishlistProvider } from './Utils/WishlistContext';
import { LanguageProvider } from './Utils/LanguageContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <StoreProvider>
        <CartProvider>
          <WishlistProvider>
            <LanguageProvider>
              <App />
            </LanguageProvider>
          </WishlistProvider>
        </CartProvider>
    </StoreProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
